import { init as initApm } from "@elastic/apm-rum"
import { ThemeProvider } from "@mui/material"
import CustomSnackbar from "components/Snackbar"
import { Suspense, useEffect } from "react"
import { Provider, useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import Loader from "./assets/images/loader.gif"
import Toaster from "./components/AlertToaster/AlertToaster"
import CreateAxiosResponseInterceptor from "./pages/Auth/components/axiosInterceptors"
import { deleteToken, setToken } from "./pages/Auth/components/verifyLoginSlice"
import SidemenuContextprovider from "./pages/Sidemenu/SidemenuContextprovider"
import AppRoutes from "./routes/AppRoutes"
import { AppDispatch, store } from "./store/Store"
import customTheme from "./styles/theme"

function App() {
    const dispatch = useDispatch<AppDispatch>()

    const location = useLocation()

    CreateAxiosResponseInterceptor()

    useEffect(() => {
        // let isAuth = localStorage.getItem('isAuth')
        location.pathname === "/auth" ? dispatch(deleteToken()) : dispatch(setToken())
    }, [])

    useEffect(() => {
        const handleWheel = (e: WheelEvent) => {
            const active = document.activeElement as HTMLInputElement | null
            if (active?.tagName === "INPUT" && active.type === "number" && active === e.target) {
                active.blur()
            }
        }
        document.addEventListener("wheel", handleWheel, { passive: true })
        return () => document.removeEventListener("wheel", handleWheel)
    }, [])

    if (process.env.REACT_APP_APM_KEY) {
        initApm({
            serviceName: "crystalina-ui",
            serverUrl: process.env.REACT_APP_APM_KEY,
            serviceVersion: "",
            environment: process.env.NODE_ENV,
            active: true,
        })
    }

    const { isAuth } = useSelector((store: any) => store.verifyLogin)

    return (
        <Provider store={store}>
            <ThemeProvider theme={customTheme}>
                <SidemenuContextprovider>
                    <Toaster />
                    <CustomSnackbar />
                    <Suspense
                        fallback={
                            <div className="loader-container center">
                                <div>
                                    <img src={Loader} alt="" />
                                    <span>I'm going to walk EEVEE</span>
                                </div>
                            </div>
                        }>
                        <AppRoutes />
                    </Suspense>
                </SidemenuContextprovider>
            </ThemeProvider>
        </Provider>
    )
}

export default App
